import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../images/logo.svg";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMenu = () => {
    setMenuActive(false);
    setDropdownOpen(false);
  };

  const navigateToPage = (path) => {
    navigate(path);
    closeMenu();
  };

  return (
    <header className={`navbar ${isScrolled ? "black" : ""}`}>
      {/* Logo */}
      <div className="logo">
        <NavLink to="/" end onClick={closeMenu}>
          <img src={Logo} alt="Total Care Advisory" />
        </NavLink>
      </div>

      {/* Mobile Menu */}
      <div className="menu">
        <button
          type="button"
          onClick={() => setMenuActive(!menuActive)}
          aria-label="Toggle menu"
        >
          ☰
        </button>
      </div>

      {/* Navigation */}
      <nav className={`nav-links ${menuActive ? "active" : ""}`}>
        {/* Home */}
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          Home
        </NavLink>

        {/* About */}
        <NavLink
          to="/about"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          About Us
        </NavLink>

        {/* Services Dropdown */}
        <div
          className={`dropdown ${dropdownOpen ? "dropdown-active" : ""}`}
          onMouseEnter={() => {
            if (window.innerWidth > 850) {
              setDropdownOpen(true);
            }
          }}
          onMouseLeave={() => {
            if (window.innerWidth > 850) {
              setDropdownOpen(false);
            }
          }}
        >
          <button
            type="button"
            className={`dropdown-title ${
              window.location.pathname.startsWith("/Sub-Pages/") ? "active" : ""
            }`}
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            Our Services
            <span className="dropdown-arrow">▼</span>
          </button>

          <ul className="dropdown-menu">
            {/* CQC Services */}
            <li>
              <NavLink
                to="/Sub-Pages/CQC_Services"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                CQC Services
              </NavLink>
            </li>

            {/* Care Home Sales */}
            <li>
              <NavLink
                to="/Sub-Pages/Care_Home"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                Care Home Sales
              </NavLink>
            </li>

            {/* Capital Allowance */}
            <li>
              <NavLink
                to="/Sub-Pages/Capital_Allowance"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                Capital Allowance
              </NavLink>
            </li>

            {/* Accounting */}
            <li>
              <NavLink
                to="/Sub-Pages/Accounting"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                Accounting
              </NavLink>
            </li>

            {/* Software */}
            <li>
              <NavLink
                to="/Sub-Pages/Software"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                Software
              </NavLink>
            </li>

            {/* Operational Management */}
            <li>
              <NavLink
                to="/Sub-Pages/Operational_Management"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                Operational Management
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Insights */}
        <NavLink
          to="/insights"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          Insights
        </NavLink>

        {/* FAQs */}
        <NavLink
          to="/faqs"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          FAQs
        </NavLink>

        {/* CQC Registration */}
        <NavLink
          to="/registration"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          CQC Registration
        </NavLink>
      </nav>

      {/* Right Side Buttons */}
      <div className="navbar-actions">
        <a
          className="Navbar-btn brochure-btn"
          href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U"
          target="_blank"
          rel="noopener noreferrer"
        >
          Product brochure
        </a>

        <button
          type="button"
          className="Navbar-btn team-btn"
          onClick={() => navigateToPage("/contact")}
        >
          Speak to Our Team
        </button>
      </div>
    </header>
  );
};

export default Header;

// import React, { useState, useEffect } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import Logo from "../../images/logo.svg";
// import "./Header.css";

// const Header = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [menuActive, setMenuActive] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 0);
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const closeMenu = () => {
//     setMenuActive(false);
//     setDropdownOpen(false);
//   };

//   const navigateToPage = (path) => {
//     navigate(path);
//     closeMenu();
//   };

//   return (
//     <header className={`navbar ${isScrolled ? "black" : ""}`}>
//       {/* Logo */}
//       <div className="logo">
//         <NavLink to="/" end onClick={closeMenu}>
//           <img src={Logo} alt="Total Care Advisory" />
//         </NavLink>
//       </div>

//       {/* Mobile Menu */}
//       <div className="menu">
//         <button
//           type="button"
//           onClick={() => setMenuActive(!menuActive)}
//           aria-label="Toggle menu"
//         >
//           ☰
//         </button>
//       </div>

//       {/* Navigation */}
//       <nav className={`nav-links ${menuActive ? "active" : ""}`}>
//         {/* Home */}
//         <NavLink to="/" end onClick={closeMenu}>
//           Home
//         </NavLink>

//         {/* About */}
//         <NavLink to="/about" onClick={closeMenu}>
//           About Us
//         </NavLink>

//         {/* Services Dropdown */}
//         <div
//           className={`dropdown ${dropdownOpen ? "dropdown-active" : ""}`}
//           onMouseEnter={() => {
//             if (window.innerWidth > 850) {
//               setDropdownOpen(true);
//             }
//           }}
//           onMouseLeave={() => {
//             if (window.innerWidth > 850) {
//               setDropdownOpen(false);
//             }
//           }}
//         >
//           <button
//             type="button"
//             className="dropdown-title"
//             onClick={() => setDropdownOpen(!dropdownOpen)}
//           >
//             Our Services
//             <span className="dropdown-arrow">▼</span>
//           </button>

//           <ul className="dropdown-menu">
//             {/* CQC Services */}
//             <li>
//               <NavLink to="/Sub-Pages/CQC_Services" onClick={closeMenu}>
//                 CQC Services
//               </NavLink>
//             </li>

//             {/* Care Home Sales */}
//             <li>
//               <NavLink to="/Sub-Pages/Care_Home" onClick={closeMenu}>
//                 Care Home Sales
//               </NavLink>
//             </li>
//             {/* Capital Allowance */}
//             <li>
//               <NavLink to="/Sub-Pages/Capital_Allowance" onClick={closeMenu}>
//                 Capital Allowance
//               </NavLink>
//             </li>

//             {/* Accounting */}
//             <li>
//               <NavLink to="/Sub-Pages/Accounting" onClick={closeMenu}>
//                 Accounting
//               </NavLink>
//             </li>

//             {/* Software */}
//             <li>
//               <NavLink to="/Sub-Pages/Software" onClick={closeMenu}>
//                 Software
//               </NavLink>
//             </li>

//             {/* Operational Management */}
//             <li>
//               <NavLink
//                 to="/Sub-Pages/Operational_Management"
//                 onClick={closeMenu}
//               >
//                 Operational Management
//               </NavLink>
//             </li>
//           </ul>
//         </div>

//         {/* Insights */}
//         <NavLink to="/insights" onClick={closeMenu}>
//           Insights
//         </NavLink>

//         {/* FAQs */}
//         <NavLink to="/faqs" onClick={closeMenu}>
//           FAQs
//         </NavLink>

//         {/* CQC Registration */}
//         <NavLink to="/registration" onClick={closeMenu}>
//           CQC Registration
//         </NavLink>
//       </nav>

//       {/* Right Side Buttons */}
//       <div className="navbar-actions">
//         <a
//           className="Navbar-btn brochure-btn"
//           href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Product brochure
//         </a>

//         <button
//           type="button"
//           className="Navbar-btn team-btn"
//           onClick={() => navigateToPage("/contact")}
//         >
//           Speak to Our Team
//         </button>
//       </div>
//     </header>
//   );
// };

// export default Header;
